import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";
import "./Resume.css";

const Resume = () => {
  useEffect(() => {
    AOS.init({ duration: 3000 });
  }, []);
  return (
    <div data-aos="fade-right" className="container resume-container">
      <div className="row">
        <div className="col-sm-12">
          <div className="title-box text-center">
            <h3 className="title-a">Resume</h3>
            <div className="line-mf"></div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">
                <strong>A short glance of my resume</strong>
              </h4>
              <div className="mt-5">
                <div className="timeline">
                  <div className="timeline-wrapper timeline-wrapper-warning">
                  <div className="timeline-badge"></div>
                    <div className="timeline-panel" data-aos="fade-up">
                      <div className="timeline-heading">
                        <h6 className="timeline-title"><strong>Skills</strong></h6>
                      </div>
                      <div className="timeline-body">
                        <p>
                          React.js, Node.js, Express.js, Mongoose, React Native,
                          Angular, Material UI, Bootstrap, SASS, Particle.js,
                          React-Router-Dom, Firebase, React-Hook-Forms.
                        </p>
                      </div>
                  
                    </div>
                  </div>
                  <div className="timeline-wrapper timeline-inverted timeline-wrapper-danger">
                  <div className="timeline-badge"></div>
                    <div className="timeline-panel" data-aos="fade-up">
                      <div className="timeline-heading">
                        <h6 className="timeline-title"><strong>Projects</strong></h6>
                      </div>
                      <div className="timeline-body">
                        <p>
                          Fit For Life, BookStand, HealthCare, Doctor's Portal
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="timeline-wrapper timeline-wrapper-success">
                  <div className="timeline-badge"></div>
                    <div className="timeline-panel" data-aos="fade-up">
                      <div className="timeline-heading">
                        <h6 className="timeline-title"><strong>Tools</strong></h6>
                      </div>
                      <div className="timeline-body">
                        <p>
                          Git, Visual Studio Code, Chrome DevTools,
                        </p>
                      </div>
                      
                    </div>
                  </div>
                  <div className="timeline-wrapper timeline-inverted timeline-wrapper-info">
                    <div className="timeline-badge"></div>
                    <div className="timeline-panel" data-aos="fade-up">
                      <div className="timeline-heading">
                        <h6 className="timeline-title"><strong>Education</strong></h6>
                      </div>
                      <div className="timeline-body">
                        <p>
                          Metropolitan University, Sylhet. <br/> Bsc. in Computer Science
                        </p>
                      </div>
                      
                    </div>
                  </div>
                  <div className="timeline-wrapper timeline-wrapper-primary">
                    <div className="timeline-badge"></div>
                    <div className="timeline-panel" data-aos="fade-up">
                      <div className="timeline-heading">
                        <h6 className="timeline-title"><strong>Courses</strong></h6>
                      </div>
                      <div className="timeline-body">
                        <p>
                        Complete Web Development Course With Jhankar Mahbub
                        </p>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
